import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReportOds } from 'src/app/data/model/custom-report';

@Component({
  standalone: false,
  selector: 'app-ods-report-dialog',
  templateUrl: './ods-report-dialog.component.html',
  styleUrls: ['./ods-report-dialog.component.scss']
})
export class OdsReportDialogComponent implements OnInit {
  tooltipText: string = '';
  public get displayedColumns(): string[] {
    return ['id_cli_ods', 'descrizione', 'stato_completamento', 'ts_inizio_reale', 'ts_fine_reale', 'city', 'waste_type']
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ReportOds[]
  ) { }

  
  ngOnInit(): void {
  }
  

  showTooltip(text: string) {
    this.tooltipText = text;
  }

  hideTooltip() {
    this.tooltipText = '';
  }
}
export type OdsReportDialogParams = {
  data: any;
};

